<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.videoList.push"
    :is-show-search-input="true"
    search-placeholder="输入视频名称进行搜索"
  >

    <v-column-time/>

    <v-column-time value="修改时间" field="update_time" sortable=""/>

    <el-table-column label="ID" prop="id"/>

    <el-table-column label="视频名称" prop="title"/>

    <el-table-column label="视频封面">
      <template v-slot="{ row }">
        <v-img :value="row.cover" class="cover"/>
      </template>
    </el-table-column>

    <el-table-column label="发布状态">
      <template v-slot="{ row }">
        <el-tag v-for="state in findVideoState(row.status)" :key="`videoState${state.id}`" :type="state.tagType">
          {{ state.name }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column label="播放量" prop="plays"/>
    <el-table-column label="评论数">
      <template v-slot="{ row }">
        {{ row.comments + row.replies }}
      </template>
    </el-table-column>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.videoEdit.to(row.id)"/>

        <v-list-button
          name="删除"
          icon="bin"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="确定要删除此视频吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`video-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>视频名称</span>
              <span>{{ v.title }}</span>
            </div>
            <div class="list-item-detail">
              <span>视频封面</span>
              <v-img :value="v.cover" class="cover"/>
            </div>
            <div class="list-item-detail">
              <span>发布状态</span>
              <div class="list-item-info">
                <el-tag
                  v-for="state in findVideoState(v.status)"
                  :key="`video-mobile-state-${v.id}-${state.id}`"
                  :type="state.tagType"
                >
                  {{ state.name }}
                </el-tag>
              </div>
            </div>
            <div class="list-item-detail">
              <span>播放量</span>
              <span>{{ v.plays }}</span>
            </div>
            <div class="list-item-detail">
              <span>评论数</span>
              <span>{{ v.comments + v.replies }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.videoEdit.to(v.id)"/>
              <v-list-button
                name="删除"
                icon="bin"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="确定要删除此视频吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/video';
import { videoStates, findVideoState } from "@/enums/videoStates";

export default {
  name: RouteConfig.videoList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {},
    videoStates,
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findVideoState,
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id }) {
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>

<style src="./index.css" scoped/>
